var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#8B909A",
    strokeWidth: 0.85,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.174 5.565c0 .384.311.696.696.696h.695l2.087 2.087V6.26h4.87a.696.696 0 0 0 .695-.696V.695A.696.696 0 0 0 12.522 0H4.87a.696.696 0 0 0-.696.696v4.87z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.13,
    cy: 9.217,
    r: 1.565
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.334 12.362A3.222 3.222 0 0 0 0 13.913h4.174"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.87,
    cy: 9.217,
    r: 1.565
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.665 12.362A3.223 3.223 0 0 1 16 13.913h-4.174"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11.304,
    r: 1.565
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.13 16a3.23 3.23 0 0 0-6.26 0h6.26zM10.435 1.74l1.391 1.39-1.391 1.392M6.957 1.74 5.565 3.13l1.392 1.392M9.391 1.739 8 4.522"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamChatIcon);
export default __webpack_public_path__ + "static/media/team-chat-icon.4f0b6b957da19ff149cfd082935e0b55.svg";
export { ForwardRef as ReactComponent };